import Modal from 'flarum/common/components/Modal';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import app from 'flarum/forum/app';
const dayjs = window.dayjs;
export default class BolillaUserDetailsModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.entry = this.attrs.entry;
    this.user = this.entry.user();
    this.season = this.attrs.season;
    this.loading = true;
    this.votes = [];
    this.loadVotes();
  }
  className() {
    return 'BolillaUserDetailsModal PlayerStatsModal Modal--large';
  }
  title() {
    return '';
  }
  loadVotes() {
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/bolilla-user-votes",
      params: {
        userId: this.user.id(),
        season: this.season,
        include: 'match'
      }
    }).then(response => {
      this.votes = app.store.pushPayload(response);
      this.loading = false;
      m.redraw();
    });
  }
  content() {
    if (this.loading) {
      return m("div", {
        className: "Modal-body"
      }, m(LoadingIndicator, null));
    }
    const totalPoints = this.entry.totalPoints();
    const gamesPlayed = this.entry.matchesVoted();
    const average = gamesPlayed > 0 ? (totalPoints / gamesPlayed).toFixed(1) : 0;
    const rows = [];
    if (this.votes.length > 0) {
      this.votes.forEach(vote => {
        const match = vote.match();
        if (!match) return;
        const isKnockout = match.isKnockout();
        if (isKnockout) {
          const points = vote.points();
          const hasScorePoint = points === 3 || points === 4;
          const hasKnockoutPoint = points === 1 || points === 4;
          rows.push(m("tr", {
            key: "".concat(vote.id(), "-score")
          }, m("td", null, m("div", {
            className: "Match-Info"
          }, m("strong", null, match.getName())), m("div", {
            className: "Date-Info",
            style: "font-size: 0.85em; color: #666;"
          }, match.matchDate() ? dayjs(match.matchDate()).format('LL') : '')), m("td", {
            className: "center"
          }, vote.votedScore()), m("td", {
            className: "center"
          }, match.getScore() || '-'), m("td", {
            className: "center bold ".concat(hasScorePoint ? 'points-positive' : '')
          }, "+", hasScorePoint ? 3 : 0)));
          rows.push(m("tr", {
            key: "".concat(vote.id(), "-knockout"),
            className: "row-knockout-detail"
          }, m("td", {
            className: "padding-left-detail"
          }, "\u2514 Eliminatoria"), m("td", {
            className: "center"
          }, vote.votedKnockoutWinner() || '-'), m("td", {
            className: "center"
          }, match.scoreAthletic() !== null ? match.getWinnerName() : '-'), m("td", {
            className: "center bold ".concat(hasKnockoutPoint ? 'points-positive' : '')
          }, m("div", {
            className: "points-breakdown"
          }, "+", hasKnockoutPoint ? 1 : 0, hasKnockoutPoint && m("div", {
            className: "points-pills"
          }, m("span", {
            className: "pill winner-pill"
          }, "+1"))))));
        } else {
          rows.push(m("tr", {
            key: vote.id()
          }, m("td", null, m("div", {
            className: "Match-Info"
          }, m("strong", null, match.getName())), m("div", {
            className: "Date-Info",
            style: "font-size: 0.85em; color: #666;"
          }, match.matchDate() ? dayjs(match.matchDate()).format('LL') : '')), m("td", {
            className: "center"
          }, vote.votedScore()), m("td", {
            className: "center"
          }, match.getScore() || '-'), m("td", {
            className: "center bold ".concat(vote.points() > 0 ? 'points-positive' : '')
          }, "+", vote.points())));
        }
      });
    }
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "Player-Modal-Header"
    }, m("div", {
      className: "Player-Profile"
    }, avatar(this.user, {
      className: 'Player-Avatar-Large'
    }), m("div", {
      className: "Player-Info"
    }, m("h2", null, username(this.user)), m("span", {
      className: "entity-tag"
    }, "La Bolilla"))), m("div", {
      className: "Player-Main-Stats"
    }, m("div", {
      className: "Stat-Box Highlight"
    }, m("span", {
      className: "label"
    }, "Puntos:"), m("span", {
      className: "value"
    }, totalPoints)), m("div", {
      className: "Stat-Box"
    }, m("span", {
      className: "label"
    }, "Partidos:"), m("span", {
      className: "value"
    }, gamesPlayed)), m("div", {
      className: "Stat-Box"
    }, m("span", {
      className: "label"
    }, "Promedio:"), m("span", {
      className: "value"
    }, average)))), m("div", {
      className: "Match-History-Section"
    }, m("h3", null, "Historial de Votos"), m("div", {
      className: "Table-Wrapper"
    }, m("table", {
      className: "Table BolillaTable--details"
    }, m("thead", null, m("tr", null, m("th", null, "Partido"), m("th", {
      className: "center"
    }, "Voto"), m("th", {
      className: "center"
    }, "Resultado"), m("th", {
      className: "center"
    }, "Puntos"))), m("tbody", null, rows.length > 0 ? rows : m("tr", null, m("td", {
      colspan: "4",
      className: "center"
    }, "No hay votos registrados.")))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/bolilla/BolillaUserDetailsModal', BolillaUserDetailsModal);